import axiosInstance from '../axiosInstance';

/**
 * Assistant Service
 * Handles the in-dashboard help assistant (chatbot) API calls.
 */
const assistantService = {
  /**
   * Ask the help assistant a question.
   * @param {string} message - the user's question
   * @param {Array<{role: string, text: string}>} history - recent conversation turns
   * @param {{roleCode?: string, orgType?: string, menuCodes?: string[]}} profile
   *        - the current user's situation, so the answer is tailored to the exact
   *          menus/terminology they see (care home vs domiciliary, etc.)
   * @returns {Promise<{success: boolean, reply: string, actions: Array}>}
   */
  ask: async (message, history = [], profile = {}) => {
    try {
      const response = await axiosInstance.post('/carehome-manager/assistant/ask', {
        message,
        context: 'manager',
        history,
        profile,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error contacting the assistant' };
    }
  },

  /**
   * Predefined quick-start questions for the welcome card. They are built on the
   * server from the same profile as the answers, so a domiciliary user is never
   * offered a care-home question (or a question about a menu they don't have).
   * Returns [] on any failure — the widget then shows its own safe defaults.
   * @param {{roleCode?: string, orgType?: string, menuCodes?: string[]}} profile
   * @returns {Promise<Array<{label: string, question: string}>>}
   */
  suggestions: async (profile = {}) => {
    try {
      const response = await axiosInstance.post('/carehome-manager/assistant/suggestions', {
        context: 'manager',
        profile,
      });
      const list = response.data?.suggestions;
      return Array.isArray(list) ? list : [];
    } catch (error) {
      return [];
    }
  },
};

export default assistantService;
